module.exports = __webpack_public_path__ + "img/harp.be5030ca.webp";